import React from 'react';
import { useIntl } from 'react-intl';

import { TaxedMoney } from '@components/containers/TaxedMoney';
import { Thumbnail } from '@components/molecules/Thumbnail';

import { translate } from '@utils/translations';

import { CONFIGURATOR_PRODUCT_TYPES } from '@temp/views/Product/types';

import * as S from './styles';
import { IProps } from './types';

export const ProductTile: React.FC<IProps> = ({ product }: IProps) => {
  const price =
    product.pricing &&
    product.pricing.priceRange &&
    product.pricing.priceRange.start
      ? product.pricing.priceRange.start
      : undefined;

  const defaultVariant = product?.defaultVariant;

  const isConfiguratorType = CONFIGURATOR_PRODUCT_TYPES.includes(
    product.productType.slug
  );

  const intl = useIntl();
  return (
    <S.Wrapper data-cy="product-tile">
      <S.Image>
        <S.Pensile />
        <S.Customize>
          {intl.formatMessage({
            defaultMessage: 'Customize',
            id: 'TXpOBi',
          })}
        </S.Customize>
        <S.Overlay />
        <Thumbnail source={product} />
      </S.Image>
      <S.Bottom>
        <S.Title>
          {isConfiguratorType
            ? product.productType.name
            : translate(product, 'name')}
        </S.Title>
        <S.Price>
          <TaxedMoney taxedMoney={defaultVariant?.pricing?.price || price} />
        </S.Price>
        <S.Category>{translate(product.category, 'name')}</S.Category>
      </S.Bottom>
    </S.Wrapper>
  );
};
